import { useAsyncData } from '#app'
import { watch } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

export function useFetchSearchBarConfiguration() {
  const $httpFetch = useHttpFetch()
  const logger = useLogger()
  const { data: configuration, error } = useAsyncData(
    'search-bar-configuration',
    () => $httpFetch('/bm/search/v3/configuration/search-bar'),
    {
      dedupe: 'defer',
    },
  )

  watch(error, () => {
    logger.info('[S&R] Impossible to fetch search bar configuration', {
      type: 'API_REQUEST_ERROR',
      owners: ['bot-squad-search-and-recommendation-front'],
    })
  })

  return {
    configuration,
  }
}
